module.exports = (__webpack_require__(4))(1719);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router/es/StaticRouter.js from dll-reference vendorProd_library
// module id = 645
// module chunks = 42